export default __webpack_public_path__ + "static/Greycliffcf-regular-webfont-0e6472c6adc42263caa80f42fb3d7352.woff";